// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__wcDNo","open":"MenuToggle_open__YHr4f"};